import { StyleRules } from '@material-ui/core/styles';
import { AlertTitleClassKey } from '@material-ui/lab/AlertTitle';

import { core as theme } from '../styles/core';

export const MuiAlertTitle: Partial<StyleRules<AlertTitleClassKey>> = {
  root: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
  },
};
